// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3OGdj","topBottomGutter":"Layout_topBottomGutter__2m2np"};